var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '../../dom';
import './CheckBox.less';
var CheckBox = /** @class */ (function (_super) {
    __extends(CheckBox, _super);
    function CheckBox(props) {
        var _this = _super.call(this, props) || this;
        _this.name = 'CheckBox';
        _this.onClick = function () {
            _this.checked = !_this.checked;
            _this.toggleClassName('&_checked', _this.checked);
            _this.props.onChange && _this.props.onChange(_this.checked);
        };
        _this.checked = Boolean(props.checked);
        var className = _this.props.className ? "".concat(_this.props.className, " &") : '&';
        _this.el = _this.DIV({ className: "".concat(className, " ").concat(_this.checked ? '&_checked' : ''), onClick: _this.onClick }, [
            _this.DIV('&__switch'),
        ]);
        return _this;
    }
    return CheckBox;
}(Component));
export { CheckBox };
